import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import EntityForm from '../../../common/components/containers/EntityForm';
import EntityTextField from '../../../common/components/containers/EntityForm/fields/EntityTextField';
import Submit from '../../../common/components/controls/Submit';
import useTranslation from '../../../common/components/utils/Translations/useTranslation';

import Header from '../../../common/layouts/AuthenticationLayout/Header';

const RestrictedOperationConfirmationForm = ({
  onSubmit,
  error,
  initialValues,
}) => {
  const { t } = useTranslation();

  const confirmationTypeName = useCallback(() => {
    const { confirmationType } = initialValues;
    switch (confirmationType) {
      case 'email':
        return t('Email');
      case 'mobile':
        return t('Mobile');
      default:
        return null;
    }
  }, [t, initialValues]);

  const name = useMemo(() => confirmationTypeName(), [confirmationTypeName]);

  const renderSubmit = useCallback(
    ({ isSubmitting }) => (
      <div className="action-section mt-10 col-xs-12">
        <Submit block isSubmitting={isSubmitting} label={t('Continue')} />
      </div>
    ),
    [t],
  );

  return (
    <>
      <Header title={t('#{name} Confirmation Required', { name })} />
      <EntityForm
        isAlwaysEditable
        entity={initialValues}
        entityName="restrictedOperationConfirmation"
        hasCreateMessage={false}
        hasUpdateMessage={false}
        hasValidateOnBlur={false}
        isNew={false}
        submitSectionRenderer={renderSubmit}
        validateOnMount={false}
        onSubmit={onSubmit}
      >
        <EntityTextField
          columns={1}
          errorMessage={error}
          label={t('#{name} Confirmation Token', { name })}
          name="confirmationToken"
        />
      </EntityForm>
    </>
  );
};

RestrictedOperationConfirmationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  error: PropTypes.string,
};

RestrictedOperationConfirmationForm.defaultProps = {
  initialValues: {},
  error: '',
};

export default RestrictedOperationConfirmationForm;
